export default {
  "adsUserPushRecord.loadingFailedRecords": "Fetching failed records…",
  "adsUserPushRecord.noFailedRecordsToRetry": "No failed records to retry",
  'adsUserPushRecord.title': 'Push Logs',
  'adsUserPushRecord.memberId': 'Member ID',
  'adsUserPushRecord.memberAccount': 'Member Account',
  'adsUserPushRecord.adsName': 'Attribution Config Name',
  'adsUserPushRecord.agentAccount': 'Agent Account',
  'adsUserPushRecord.adsType': 'Attribution Channel',
  'adsUserPushRecord.status': 'Status',
  'adsUserPushRecord.eventName': 'Event Name',
  'adsUserPushRecord.dateRange': 'Date Range',
  'adsUserPushRecord.search': 'Search',
  'adsUserPushRecord.reset': 'Reset',
  'adsUserPushRecord.userId': 'User ID',
  'adsUserPushRecord.userName': 'User Name',
  'adsUserPushRecord.agentName': 'Agent Name',
  'adsUserPushRecord.pushTime': 'Push Time',
  'adsUserPushRecord.action': 'Action',
  'adsUserPushRecord.viewParams': 'View Parameters',
  'adsUserPushRecord.retry': 'Retry',
  'adsUserPushRecord.paramDetail': 'Parameter Details',
  'adsUserPushRecord.paramDisclaimer': '*Parameters on this page are for reference only, subject to the attribution provider\'s docking documentation*',
  'adsUserPushRecord.batchRetryTitle': 'Batch Retry',
  'adsUserPushRecord.batchRetryConfirm': 'The following failed records will be retried in this batch:',
  'adsUserPushRecord.batchRetryItem': '• Member Account: {account}, Event: {event}, Push Time: {time}',
  'adsUserPushRecord.batchRetryWarning': 'Please confirm batch retry, this operation cannot be undone.',
  'adsUserPushRecord.confirm': 'Confirm',
  'adsUserPushRecord.cancel': 'Cancel',
  'adsUserPushRecord.retrySuccess': 'Retry successful',
  'adsUserPushRecord.retryFailed': 'Retry failed',
  'adsUserPushRecord.batchRetrySuccess': 'Batch retry successful',
  'adsUserPushRecord.batchRetryFailed': 'Batch retry failed',
  'adsUserPushRecord.fetchDataFailed': 'Failed to fetch data',
  'adsUserPushRecord.fetchAgentsFailed': 'Failed to fetch agent list',
  'adsUserPushRecord.fetchFailedRecordsFailed': 'Failed to fetch failed records',
  'adsUserPushRecord.pagination': 'Page {current} of {page}, Total {total} records',
  'adsUserPushRecord.noData': 'No data',
};
